<template>
  <v-container>
    <v-layout row wrap mt-5 pb-3>
      <v-flex xs12>
        <h3>
          <v-icon large color="yellow">send</v-icon>
          Resend Order
        </h3>
        After an error is eliminated there might be the demand to resend an
        order that previously failed for this cause.
        <blockquote>
          Please enter the Shop Order No. of an existing order to resend it 1:1
          to the ERP system.
        </blockquote>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs9><resend-order-form class="pa-5"></resend-order-form></v-flex>
    </v-layout>

    <v-layout row wrap mt-5 pb-3>
      <v-flex xs12>
        <h3>
          <v-icon large color="yellow">reply_all</v-icon>
          Orders missing result
        </h3>
      </v-flex>
    </v-layout>
    <v-layout row wrap mb-5 elevation-3>
      <v-flex xs12>
        <order-missing-result-list></order-missing-result-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ResendOrderForm from "@/components/ResendOrderForm";
import OrderMissingResultList from "@/components/OrderMissingResultList.vue";

export default {
  components: {
    ResendOrderForm,
    OrderMissingResultList
  }
};
</script>
